'use client';

import { c as _c } from "react/compiler-runtime";
import { VideoProcessingWarning } from '@/app/[locale]/(worlds)/[roomId]/components/VideoProcessingStatus';
import World from '@/app/[locale]/(worlds)/[roomId]/components/World';
import WorldInfoPanel from '@/app/[locale]/(worlds)/[roomId]/components/WorldInfoPanel';
import WorldThankYouDialog from '@/app/[locale]/(worlds)/[roomId]/components/WorldThankYouDialog';
import { WORLD_CONTENT_COL_WIDTH } from '@/constants/content-detail-layout';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import { useScrollLock } from '@/hooks/useScrollLock';
import { cn } from '@/lib/utils';
function WorldContentDetail() {
  const $ = _c(12);
  const {
    isMobileLandscape
  } = useUAContext();
  const {
    setScrollLock
  } = useScrollLock();
  const {
    isOwnerViversePro
  } = useCheckEnterRoomContext();
  const t0 = !isOwnerViversePro;
  let t1;
  if ($[0] !== isMobileLandscape || $[1] !== isOwnerViversePro || $[2] !== t0) {
    t1 = cn("flex w-full flex-col gap-4 md:max-w-full md:min-w-full md:gap-6 lg:col-start-1 lg:row-start-1", {
      "grid grid-cols-2": isMobileLandscape,
      "lg:max-w-full lg:min-w-0": isOwnerViversePro,
      [WORLD_CONTENT_COL_WIDTH]: t0
    });
    $[0] = isMobileLandscape;
    $[1] = isOwnerViversePro;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <VideoProcessingWarning />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setScrollLock) {
    t3 = <div className="relative"><World className="aspect-video" setScrollLock={setScrollLock} /></div>;
    $[5] = setScrollLock;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <WorldThankYouDialog />;
    t5 = <WorldInfoPanel />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t3) {
    t6 = <div data-section="world-content" className={t1}>{t2}{t3}{t4}{t5}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export default WorldContentDetail;